module.exports = __webpack_public_path__ + "static/media/notification.e06a284f.svg";